import { GET_USER_PROFILE_SUCCESS } from "../actions/servicesAction"


const userProfileReducer = (state = [], { type,  payload=[] }) => {
  switch (type) {
    case GET_USER_PROFILE_SUCCESS:
      return payload
    default:
      return state
  }
}

export default userProfileReducer